<dynamic-form
  *ngIf="formGroup && isOkForLoad && columns?.length > 0"
  [apiName]="apiName"
  [group]="formGroup"
  [areaName]="areaName"
  [label]="label"
  [model]="model"
  [columns]="columns"
  [defaultHeight]="35"
  [isShowModal]="false"
  [submitButtonDisabled]="submitButtonDisabled()"
  [erroremessage]="erroremessage"
  [hasDefault]="false"
  [filterLookUp]="filterLookUp"
  (valueChangeByApiName)="onChange($event)"
  (cancelChange)="cancel()"
  (submitChange)="save()">
  <ng-container class="fctContent" *ngIf="HasJournalVoucher">
    <div class="form-item" *ngIf="detailLedgerLevel >= 2">
      <ssg-select
        name="DetailLedger2Id"
        [group]="formGroup"
        dropdownPosition="auto"
        limitSelection="5"
        [defaultHeight]="35"
        [label]="'ClientApp.BackOffice.ACC.SubLedger.DetailLedger2' | translate"
        apiName="DetailLedger/ReadLookUp"
        textFieldName="Title"
        valueFieldName="Id">
      </ssg-select>
    </div>
    <div class="form-item" *ngIf="detailLedgerLevel >= 3">
      <ssg-select
        name="DetailLedger3Id"
        [group]="formGroup"
        dropdownPosition="auto"
        limitSelection="5"
        [defaultHeight]="35"
        [label]="'ClientApp.BackOffice.ACC.SubLedger.DetailLedger3' | translate"
        apiName="DetailLedger/ReadLookUp"
        textFieldName="Title"
        valueFieldName="Id">
      </ssg-select>
    </div>
    <div class="form-item" *ngIf="detailLedgerLevel >= 4">
      <ssg-select
        name="DetailLedger4Id"
        [group]="formGroup"
        dropdownPosition="auto"
        limitSelection="5"
        [defaultHeight]="35"
        [label]="'ClientApp.BackOffice.ACC.SubLedger.DetailLedger4' | translate"
        apiName="DetailLedger/ReadLookUp"
        textFieldName="Title"
        valueFieldName="Id">
      </ssg-select>
    </div>
    <div class="form-item" *ngIf="detailLedgerLevel >= 5">
      <ssg-select
        name="DetailLedger5Id"
        [group]="formGroup"
        dropdownPosition="auto"
        limitSelection="5"
        [defaultHeight]="35"
        [label]="'ClientApp.BackOffice.ACC.SubLedger.DetailLedger5' | translate"
        apiName="DetailLedger/ReadLookUp"
        textFieldName="Title"
        valueFieldName="Id">
      </ssg-select>
    </div>
  </ng-container>
  <ng-container class="content" *ngIf="formGroup && isOkForLoad">
    <ng-container class="detail" *ngIf="currentVoucherKind && InvVoucherDetailColumns && InvVoucherDetailColumns.length > 0">
      <invvoucher-detail
        #detail
        (rowChanges)="onValueChanges($event)"
        (valueChanges)="onValueChanges($event)"
        [isPriceable]="Priceable"
        [detailLedgerLevel]="detailLedgerLevel"
        [isAdd]="!isNoValidForEdit()"
        [isEdit]="!isNonValidEdit"
        [StatusKindCode]="model?.StatusKindCode"
        [isDelete]="!isNoValidForEdit()"
        [AccountRegistered]="model?.StatusKindCode === 3"
        [HasJournalVoucher]="HasJournalVoucher"
        [hasDiscount]="hasDiscount"
        [headerTitleToDetailTitle]="headerTitleToDetailTitle"
        [hasReferenceRequired]="hasReferenceRequired"
        [hasReference]="hasReference"
        [IsReturnPurchaseInvoice]="IsReturnPurchaseInvoice"
        [IsPurchaseInvoice]="IsPurchaseInvoice"
        [filterEntity]="filterEntity"
        (forGoodsGroupBy)="SetGoodsGroupBy()"
        [ReferenceVoucherKindId]="ReferenceVoucherKindId"
        [CurrentVoucherKind]="currentVoucherKind"
        [columns]="InvVoucherDetailColumns"
        [gridHeight]="getGridHeight"
        [aggregatesColumnName]="'Amount,Price,Surplusage,Deduction,DiscountAmount,Tax,TotalPrice'"
        [CurrentWarehouseId]="formGroup?.controls['WarehouseId']?.value"
        [ReferenceVoucherChange]="onReferenceVoucherChange"
        [RowNumberName]="'RowNumber'"
        [(dataList)]="model.InvVoucherDetailList">
      </invvoucher-detail>
    </ng-container>
    <div class="footer" *ngIf="this.Priceable === true || this.HasTransportInterface === true || this.ShowStockAmount == true">
      <div class="InvBalanceColumns">
        <kgrid
          *ngIf="ShowStockAmount && StockInfoColumns && StockInfoColumns.length > 0"
          [label]="label"
          [name]="apiName"
          [columns]="StockInfoColumns"
          [(dataList)]="filterdDataList"
          [isAdd]="false"
          [isEdit]="false"
          [isDelete]="false"
          [groupable]="false"
          [filtering]="false"
          [hideToolber]="true">
        </kgrid>
      </div>
      <div class="transportColumns" *ngIf="HasTransportInterface">
        <form-control-model
          [isShowModal]="false"
          [columns]="transportColumns"
          [group]="formGroup"
          (valueChangeWithName)="onvalueChangeWithName($event)"
          (valueChangeByApiName)="onChanged($event)"
          [model]="model">
        </form-control-model>
      </div>
      <div class="footerColumns" *ngIf="Priceable">
        <form-control-model [defaultHeight]="30" [isShowModal]="false" [columns]="footerColumns" [group]="formGroup" [model]="model">
        </form-control-model>
      </div>
    </div>
  </ng-container>
  <ng-container class="footer">
    <ssg-button class="btnstyle" (click)="ngOnInit()" data-tooltip="top" tooltip="بازخوانی اطلاعات" icon="icon-refresh-o"> </ssg-button>
    <ssg-button icon="icon-list-f" buttontype="button" (click)="loadVoucherList()" class="btnstyle" tooltip="لیست اسناد" [disabled]="false">
    </ssg-button>
    <ssg-button icon="icon-file-document-multiple-outline" buttontype="button" (click)="newVoucher()" class="btnstyle" tooltip="سند جدید">
    </ssg-button>
    <ssg-button
      icon="icon-auto_delete-o"
      buttontype="button"
      (click)="deleteVoucher()"
      class="btnstyle"
      tooltip="حذف سند"
      [disabled]="model?.StatusKindCode >= 2 || isNewRow">
    </ssg-button>

    <ssg-button
      *hasPermission="['Inventory:InvVoucherHeader/CreateAccVoucher', 'Same']"
      icon="icon-create_new_folder-o"
      (click)="this.isCreatingAccVoucher = false; accountAccVoucher(true)"
      buttontype="button"
      class="btnstyle"
      tooltip="صدور سند حسابداری"
      [disabled]="!HasJournalVoucher || isNewRow || model?.AccVoucherHeaderId"
      appearance="flat">
    </ssg-button>
    <ssg-button
      *hasPermission="['Inventory:InvVoucherHeader/DeleteAccVoucher', 'Same']"
      icon="icon-delete-sweep-outline"
      (click)="accountAccVoucher(false)"
      buttontype="button"
      class="btnstyle"
      tooltip="حذف سند حسابداری"
      [disabled]="!HasJournalVoucher || isNewRow || !model?.AccVoucherHeaderId">
    </ssg-button>
    <ssg-button
      *hasPermission="['Inventory:InvVoucherHeader/ViewAccVoucher', 'Same']"
      icon="icon-table_view-f"
      (click)="viewAccVoucher()"
      buttontype="button"
      class="btnstyle"
      tooltip="نمایش سند حسابداری"
      [disabled]="!HasJournalVoucher || !model?.AccVoucherHeaderId">
    </ssg-button>
    <ssg-button
      icon="icon-folder-open-outline"
      buttontype="button"
      (click)="voucherConfirm()"
      class="btnstyle"
      [tooltip]="confirmLabel"
      [disabled]="model?.StatusKindCode > 2 || isNewRow">
    </ssg-button>
    <ssg-button
      (click)="deleteRowsWithoutValues()"
      buttontype="button"
      class="action-btn"
      label="حذف اقلام بدون مقدار"
      [disabled]="model?.StatusKindCode > 1">
    </ssg-button>
    <ssg-button
      (click)="ReplaceGoodsSimilar()"
      buttontype="button"
      class="action-btn"
      label="جایگزین کالای مشابه"
      [disabled]="!isFristReplaceGoodsSimilar">
    </ssg-button>
    <ssg-button
      icon="fa fa-filter"
      (click)="PriceRefresh()"
      buttontype="button"
      class="action-btn"
      label="بازیابی قیمت"
      [disabled]="!hasPriceRefresh">
    </ssg-button>
    <ssg-menu
      *ngIf="ReferenceToVoucherKinds && ReferenceToVoucherKinds.length >= 0 && !isNewRow"
      icon="icon-content_copy-o"
      class="btnstyle"
      tooltip="معطوف">
      <ng-container class="menuitem">
        <div>
          <div *ngFor="let voucherKind of ReferenceToVoucherKinds" class="reportbtn">
            <button class="btn" (click)="changeReferenceToVoucherKind(voucherKind.Id)">{{ voucherKind.Title }}</button>
          </div>
        </div>
      </ng-container>
    </ssg-menu>

    <ssg-menu *ngIf="!isNewRow" icon="icon-print-o" class="btnstyle" tooltip="چاپ">
      <ng-container class="menuitem">
        <div>
          <div *ngFor="let report of reportKinds" class="reportbtn">
            <button class="btn" (click)="changeReport(report.value)">{{ report.name }}</button>
          </div>
        </div>
      </ng-container>
    </ssg-menu>
  </ng-container>
</dynamic-form>
